import { render, staticRenderFns } from "./ValidateIQ.vue?vue&type=template&id=4a41f371"
import script from "./ValidateIQ.vue?vue&type=script&lang=js"
export * from "./ValidateIQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports